import React from "react";
import {Box, HStack, Image, Text} from "@chakra-ui/react";
import mark from "../assets/logo-mark.png";

// House mark from logo.png plus a text wordmark, so the name stays legible at header size.
function Logo({light = false, size = {base: "40px", lg: "48px"}}) {
    return (
        <HStack spacing={3}>
            <Image src={mark} alt="" boxSize={size} flexShrink={0}/>
            <Box fontFamily="heading" textTransform="uppercase" lineHeight={1}>
                <Text fontWeight={700} fontSize={{base: "lg", lg: "xl"}} letterSpacing="0.05em" color={light ? "white" : "ink.900"}>
                    MJ Carpentry
                </Text>
                <Text fontWeight={600} fontSize={{base: "2xs", lg: "xs"}} letterSpacing="0.3em" mt={1}
                      color={light ? "whiteAlpha.700" : "brand.500"}>
                    and Joinery
                </Text>
            </Box>
        </HStack>
    );
}

export default Logo;
